import { SOGetDeficiency } from '../deficiency/so-get-deficiency';
import { SOGetPeriod } from '../period/so-get-period';
import { SOGetBacklog } from '../backlog/so-get-backlog';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetWork implements QueryProtocol {

  constructor(
    public uid: string = null,
    public name: string = null,
    public number: number = null,
    public active: boolean = null,
    public deficiency: SOGetDeficiency = null,
    public period: SOGetPeriod = null,
    public backlog: SOGetBacklog = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetWork(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'number' in params ? params.number : null,
      'active' in params ? params.active : null,
      'deficiency' in params ? params.deficiency : null,
      'period' in params ? params.period : null,
      'backlog' in params ? params.backlog : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
